import { render, staticRenderFns } from "./Cuentas.vue?vue&type=template&id=4f8d61c3&"
import script from "./Cuentas.vue?vue&type=script&lang=js&"
export * from "./Cuentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports